module.exports = __webpack_public_path__ + "img/crw.d21b8965.svg";